var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASUlEQVR42mMYBTQGjMHnzoAw2ZoZLCaAMYhNnmbNfAhGGELYuWia0Q2BY2wGuDOoZ3aBMJCbhg3D5BFqMIEKHEMAXjWjyYxKAAALmzOGfWifiQAAAABJRU5ErkJggg==";
  export default img;